import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";

// * Import kits
import Typography from "../../kit/Typography";

// * Import data
import { MESSAGES } from "../../utils/config";

import { useTheme } from "@mui/styles";
import { accountSetupStyles } from "../../theme/style";

// # Component
const FinalScreen = ({ setActiveScreen, tabName }) => {
  const theme = useTheme();
  const classes = accountSetupStyles(theme);
  const navigate = useNavigate();
  // # JSX
  return (
    <>
      <Typography variant="h5" sx={{ lineHeight: theme.size[36] }}>
        {MESSAGES.FINAL_SCREEN_MESSAGE}
      </Typography>
      <Button
        disableRipple
        className={classes.accountSetupButton}
        onClick={() => {
          navigate("/discover");
        }}
      >
        {MESSAGES.FINAL_SCREEN_BUTTON_TEXT}
      </Button>
    </>
  );
};

// # Exports
export default FinalScreen;
